import React from "react";

// Color Picker Component
const ColorPicker = ({ label, color, setColor }) => {
  return (
    <div className="flex flex-col gap-1">
      <label className="text-sm text-slate-500">{label}</label>
      <div className="flex items-center">
        <input
          type="color"
          value={color}
          onChange={(e) => setColor(e.target.value)}
          className="w-10 h-10 p-0 border-none cursor-pointer rounded"
          title="Choose a color"
        />
        <span className="ml-2 font-mono">{color}</span>
      </div>
      {label == "Background Color" && (
        <button
          type="button"
          onClick={() => setColor("")}
          className="text-sky-600 underline text-start text-xs"
        >
          Transparent
        </button>
      )}
    </div>
  );
};

export default ColorPicker;
